import { useEffect, useState } from 'react'
import { useImmer } from 'use-immer'
import { Box, Button, Card, CardBody, CardHeader, Flex, FormControl, FormLabel, Heading, Input, VStack } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { useAppContext } from 'hooks/useAppContext'
import { getMowCurbPricingConfig, setMowCurbPricingConfig } from 'api'

const BreadcrumbNav = [
  {
    label: 'Mow Curb Pricing',
    isCurrentPage: true
  }
]

export const MowCurbPricingForm = () => {
  const { createToast } = useAppContext()
  const [form, setForm] = useImmer({
    mowCurbBase: 0,
    mowCurbPerFoot: 0
  })
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getMowCurbPricingConfig()
        setForm(draft => {
          draft.mowCurbBase = response.mowCurbBase
          draft.mowCurbPerFoot = response.mowCurbPerFoot
        })
      } catch (err) {
        createToast('error', 'Error', err.response?.data || 'Failed to load mow curb config')
      }
    }
    load()
  }, [])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsSaving(true)
    try {
      await setMowCurbPricingConfig({
        mowCurbBase: parseFloat(form.mowCurbBase),
        mowCurbPerFoot: parseFloat(form.mowCurbPerFoot)
      })
      createToast('success', 'Successfully updated.')
      setIsSaving(false)
    } catch (err) {
      createToast('error', 'Error', err.response?.data || 'Failed to save mow curb config')
      setIsSaving(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Mow Curb Pricing</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Configuration</Heading>
          </CardHeader>
          <CardBody p={8}>
            <form onSubmit={handleSubmit}>
              <VStack gap={2} maxW="500px">
                <FormControl isRequired>
                  <FormLabel>Base Price</FormLabel>
                  <Input type="number" name="mowCurbBase" value={form.mowCurbBase} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Price Per Foot</FormLabel>
                  <Input type="number" name="mowCurbPerFoot" value={form.mowCurbPerFoot} onChange={handleChange} />
                </FormControl>
              </VStack>
              <Button type="submit" mt={8} colorScheme="blue" isLoading={isSaving}>Save</Button>
            </form>
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
